import { PciI } from "interfaces/Pci";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { PCIRow } from "./PCIRow";
import { PCIDetailModal } from "../PCIDetailModal/PCIDetailModal";
import { PCICompareModal } from "../PCICompareModal/PCICompareModal";

interface Props {
  elementos: PciI[];
  renderActions?: (
    elemento: PciI,
    onClickShowDetail: (elemento: PciI) => void,
    onClickCompare: (elemento: PciI) => void,
  ) => ReactNode;
}

export const PCITable = ({ elementos = [], renderActions }: Props) => {
  const [selectedElement, setSelectedElement] = useState<PciI | null>(
    null,
  );
  const [showModal, setShowModal] = useState(false);

  const [compareElement, setCompareElement] = useState<PciI | null>(null);
  const [showCompareModal, setShowCompareModal] = useState(false);

  const onCloseDetailModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedElement(null);
    }, 400);
  };

  const onShowDetailModal = (elemento: PciI) => {
    setSelectedElement(elemento);
    setShowModal(true);
  };

  const onCloseCompareModal = () => {
    setShowCompareModal(false);
    setTimeout(() => {
      setCompareElement(null);
    }, 400);
  };

  const onShowCompareModal = (elemento: PciI) => {
    setCompareElement(elemento);
    setShowCompareModal(true);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Año implementación</th>
            <th>Plan de estudio</th>
            <th>Institución</th>
            <th>Estado</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <PCIRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={
                  renderActions
                    ? (e) => renderActions(e, onShowDetailModal, onShowCompareModal)
                    : undefined
                }
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 7 : 6}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay PCI para visualizar.</b> Para poder
                  visualizar PCI debes <br /> seleccionar el botón
                  agregar «Nuevo PCI».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <PCIDetailModal
        elemento={selectedElement}
        showModal={showModal}
        onClose={onCloseDetailModal}
      />
      <PCICompareModal
        elementoA={compareElement}
        showModal={showCompareModal}
        onClose={onCloseCompareModal}
      />
    </>
  );
};
